import React, { useState } from 'react';

function IBANInput() {
  const [iban, setIBAN] = useState('PT50 ');

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Remove "PT50 " and any non-digit characters
    const numericValue = inputValue.replace(/^PT50\s*|\D+/g, '');

    // Limit to 21 numeric characters
    const limitedValue = numericValue.substring(0, 21);

    // Format with spaces every 4 characters
    const formattedValue = limitedValue.match(/.{1,4}/g);

    setIBAN(`PT50 ${formattedValue ? formattedValue.join(' ') : ''}`);
  };

  return (
    <div>
      <input
        type="text"
        id="nib"
        value={iban}
        onChange={handleInputChange}
        placeholder="PT50 1234 5678 9012 3456 7"
        className = 'input-1' 
        
      />
    </div>
  );
}

export default IBANInput;